import { audioUploadHandler, uploadHandler } from "../../api/upload";
import { fetchUserMedia, fetchUserMusics } from "../../api/user";
import {
  setIdle,
  setImageLoading,
  setImageUploading,
} from "../../store/common/appStateSlice";
// import { setCollections, setImages } from "../../store/media/mediaSlice";
import {
  setCollections,
  setImages,
  setMusics,
} from "../../store/media/mediaSlice";
import { secondsToTime, wrapCustomImages } from "../../utils";
import { showToast } from "../../utils/general";
import { getFromLocal } from "../../utils/localStorage";
import { getUserAudioScript } from "./scriptThunks";

export const handleMyMediaUpload =
  (fileHandle) => async (dispatch, getState) => {
    const { images } = getState().media;
    dispatch(setImageUploading());
    const media = await uploadHandler(getFromLocal("userId"), fileHandle);
    dispatch(setImages(wrapCustomImages([...images, media])));
    dispatch(setIdle());
  };

export const loadMyUploads = (fileHandle) => async (dispatch) => {
  dispatch(setImageLoading());
  const images = wrapCustomImages(await fetchUserMedia(getFromLocal("userId")));
  dispatch(setCollections([]));
  dispatch(setImages(images));
  dispatch(setIdle());
};

export const handleMyMusicUpload =
  (fileHandle) => async (dispatch, getState) => {
    const { musics } = getState().media;
    dispatch(setImageUploading());
    const music = await uploadHandler(
      getFromLocal("userId"),
      fileHandle,
      "audio"
    );
    dispatch(setMusics([...musics, music]));
    dispatch(setIdle());
  };

export const loadMyMusics = (fileHandle) => async (dispatch) => {
  dispatch(setImageLoading());
  const musics = await fetchUserMusics(getFromLocal("userId"));
  dispatch(setCollections([]));
  dispatch(setMusics(musics));
  dispatch(setIdle());
};

export const uploadAudioScript = (fileHandle) => async (dispatch) => {
  const reader = new FileReader();
  const audioElement = document.createElement("audio");
  reader.onload = (e) => {
    audioElement.src = e.target.result;
    const timer = setInterval(async () => {
      if (audioElement.readyState === 4) {
        const getTime = secondsToTime(audioElement.duration);

        clearInterval(timer);
        if (getTime > 60) {
          showToast(
            `Max duration of the audio file can be ${60} seconds.`,
            "",
            "danger"
          );
          return;
        }
        dispatch(setImageUploading());
        const res = await audioUploadHandler(
          getFromLocal("userId"),
          fileHandle
        );

        if (res.audio) {
          dispatch(getUserAudioScript());
        }
        dispatch(setIdle());
      }
    }, 500);
  };
  reader.readAsDataURL(fileHandle);
};
